module.exports = __webpack_public_path__ + "img/navbar-icon-back.b8e1ae79.svg";